document.addEventListener('DOMContentLoaded', () => {
  const actualProjectsCollapseContainerEls = document.querySelectorAll('.actual-projects-collapse-container');

  actualProjectsCollapseContainerEls.forEach(actualProjectsCollapseContainer => {
    const actualProjectsEntryEls = actualProjectsCollapseContainer.querySelectorAll('.project-entry');

    if (actualProjectsEntryEls.length > 0) {
      actualProjectsEntryEls[0].children[1].classList.remove('is-hidden');
      actualProjectsEntryEls[0].children[1].removeAttribute('aria-hidden');
      actualProjectsEntryEls[0].children[2].children[0].innerText = 'Weniger anzeigen';
      actualProjectsEntryEls[0].children[2].classList.add('is-open');
      actualProjectsEntryEls.forEach(el => {
        const description = el.querySelector('.project-description');
        const button = el.querySelector('.more-btn');
        const buttonSpan = button.querySelector('span');
        button.addEventListener('click', () => {
          description.classList.toggle('is-hidden');
          button.classList.toggle('is-open');
          if (description?.classList.contains('is-hidden')) {
            description.setAttribute('aria-hidden', 'true');
            buttonSpan.innerText = 'Mehr anzeigen';
          } else {
            description.removeAttribute('aria-hidden');
            buttonSpan.innerText = 'Weniger anzeigen';
          }
        });
      });
    }
  });
});
